import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface SkipProcessModalProps {
  onClose: () => void
  onConfirm: () => void
}

const cardFeatures = () => [
  i18n.t('expenses_v2.cards.blocks.skip_process_modal.card_features.card_types'),
  i18n.t('expenses_v2.cards.blocks.skip_process_modal.card_features.apple_google_pay'),
  i18n.t('expenses_v2.cards.blocks.skip_process_modal.card_features.expense_management_optimized'),
  i18n.t(
    'expenses_v2.cards.blocks.skip_process_modal.card_features.software_subscription_management'
  ),
  i18n.t('expenses_v2.cards.blocks.skip_process_modal.card_features.secured_payment'),
]

const SkipProcessModal = ({ onClose, onConfirm }: SkipProcessModalProps) => {
  const Footer = (
    <Box flexDirection="row" justifyContent="flexStart" gap="s8">
      <Button type="secondary" onClick={onConfirm}>
        {i18n.t('expenses_v2.cards.blocks.skip_process_modal.actions.dismiss')}
      </Button>
      <Button type="primary" onClick={onClose}>
        {i18n.t('expenses_v2.cards.blocks.skip_process_modal.actions.complete')}
      </Button>
    </Box>
  )

  return (
    <Modal
      title={i18n.t('expenses_v2.cards.blocks.skip_process_modal.title_v2')}
      illustration="alert"
      footer={Footer}
      onClose={onClose}
    >
      <Box flexDirection="column" gap="s24">
        <Text size="300">
          {i18n.t('expenses_v2.cards.blocks.skip_process_modal.description_v2')}
        </Text>

        <Box role="list" gap="s16">
          {cardFeatures().map((cardFeature) => (
            <Box key={cardFeature} role="listitem" flexDirection="row" gap="s6">
              <Icon.Medium icon="check-circle" color="grey800" />
              <Text size="300">{cardFeature}</Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Modal>
  )
}
export default SkipProcessModal
